import React from "react";
import { Tag } from "antd";
import { CrownOutlined, GiftOutlined } from "@ant-design/icons";

const TierBadge = ({ tier }) => {
  if (tier === "PRO") {
    return (
      <Tag icon={<CrownOutlined />} color="gold">
        PRO
      </Tag>
    );
  }
  return (
    <Tag icon={<GiftOutlined />} color="default">
      STARTER (Ücretsiz)
    </Tag>
  );
};

export default TierBadge;
